<div class="status-item">
    <div [class]="'icon ' + iconType">
        <i [ngClass]="iconClass"></i>
    </div>
    <div class="content">
        <ng-content></ng-content>
    </div>
    @if (divider) {
    <div class="divider"></div>
    }
</div>